import { SubscriberComponent } from '@trustedshops/tswp-core-ui-implementation';
import { Subscription } from 'rxjs';

import { Component, OnDestroy } from '@angular/core';

@Component({
  template: '',
})
export abstract class RxJsSubscriberComponent extends SubscriberComponent implements OnDestroy {
   //#region Private Fields
   private readonly _subscriptions: Subscription[] = [];
   //#endregion

   //#region Public Methods
   /**
    * Removes all remembered subscriptions
    */
   public ngOnDestroy(): void {
     this._subscriptions.forEach(subscription =>
       subscription?.unsubscribe());
   }
   //#endregion

   //#region Private Methods
   /**
    * Utility method to register a created subscription.
    * When the child class does not override/extend the `ngOnDestroy` method,
    * the registered subscriptions are going to be unsubscribed.
    *
    * @param subscription The subscription to unregister on component destruction
    */
   protected rememberSubscription(...subscriptions: Subscription[]): SubscriberComponent {
     this._subscriptions.push(...subscriptions);
     return this;
   }
   //#endregion
}
